// Is the server reachable (QA-058)? Calls and the live stream report what they see; the screen
// shows a calm line while it isn't. Nothing here decides that a change was saved: only the
// server's answer does.
import { useSyncExternalStore } from 'react';

let online = true;
const listeners = new Set<() => void>();

export function reportConnection(ok: boolean): void {
  if (ok === online) return;
  online = ok;
  for (const l of listeners) l();
}

export const isOnline = () => online;

export function useOnline(): boolean {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => online,
  );
}

// The browser knows first when the network itself is gone; it coming back proves nothing until
// the server answers.
if (typeof window !== 'undefined') window.addEventListener('offline', () => reportConnection(false));
